import SearchAccountBaseForm from './SearchAccountBaseForm';

export default SearchAccountBaseForm;
